import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles<Theme>((theme) =>
  createStyles({
    container: {
      width: '100%',
      height: '100vh',
      position: 'relative',
      [theme.breakpoints.down(480)]: {
        width: '100%',
        borderRadius: '13px',
      },
    },
    containerImages: {
      height: '300px',
      [theme.breakpoints.down('xs')]: {
        overflowX: 'scroll',
      },
      [theme.breakpoints.down(480)]: {
        '&::-webkit-scrollbar-thumb': {
          display: 'none',
        },
        height: '200px',
        width: '100%',
      },
    },
    img: {
      height: '100%',
      borderRadius: '13px',
      backgroundColor: '#e3e3e3',
      objectFit: 'fill',
      '& + img': {
        marginLeft: '10px',
      },
    },
    containerDetails: {
      display: 'flex',
      justifyContent: 'space-between',
      position: 'absolute',
      top: 260,
      right: '15%',
      width: '70%',
      height: '400px',
      padding: theme.spacing(2, 3),
      backgroundColor: '#FFFFFF',
      border: '1px solid #fcfcfc',
      borderRadius: '13px',
      boxShadow: '0px 5px 20px #64646433',
      [theme.breakpoints.down(480)]: {
        width: '100%',
        flexDirection: 'column',
        backgroundColor: 'none',
        boxShadow: 'none',
        border: '0',
        top: 'auto',
        right: 0,
      },
    },
    contentDetails: {
      display: 'flex',
      flexDirection: 'column',
      width: '420px',
      [theme.breakpoints.down(480)]: {
        width: '100%',
      },
    },
    header: {
      display: 'flex',
      width: '100%',
      marginBottom: '16px',
      justifyContent: 'space-between',
      alignItems: 'baseline',
    },
    main: {
      display: 'flex',
      justifyContent: 'space-between',
      maxWidth: '300px',
      marginBottom: '14px',
      width: '100%',
    },
    brandCar: {
      color: '#646464',
      fontSize: '22px',
      textTransform: 'uppercase',
      marginRight: '4px',
      [theme.breakpoints.down(480)]: {
        fontSize: '16px'
      },
    },
    nameCar: {
      color: theme.palette.primary.main,
      fontSize: '22px',
      textTransform: 'uppercase',
      fontWeight: 'bold',
      [theme.breakpoints.down(480)]: {
        fontSize: '16px'
      },
    },
    fipePrice: {
      color: '#C4C4C4',
      fontSize: '14px',
      textAlign: 'right',
      fontWeight: 'bold',
      [theme.breakpoints.down(480)]: {
        fontSize: '10px'
      },
    },
    comonTitle: {
      color: '#C4C4C4',
      fontWeight: 'bold',
      fontSize: '11px',
    },
    accessories: {
      width: '200px',
      paddingTop: '10px',
      [theme.breakpoints.down(480)]: {
        marginLeft: '80px',
      }
    },
    accessoriesContent: {
      height: '300px',
      overflow: 'auto',
      [theme.breakpoints.down(480)]: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        '-webkit-line-clamp': 2,
        '-webkit-box-orient': 'vertical',
      }
    },
    button: {
      height: '33px',
      padding: '5px 20px',
      color: '#ffffff',
      backgroundColor: '#0047BA',
      border: '1px solid #0047BA',
      borderRadius: '17px',
      marginBottom: '20px',
      fontWeight: 'bold',
      cursor: 'pointer',
      '&:disabled':{
        backgroundColor: '#E4F4FB',
        color: '#0047BA',
        fontWeight: 'bold',
        cursor: 'unset'
      }
    },
    strong: {
      display: 'block',
      '& + strong': {
        marginTop: '10px',
      },
    },
    ToolTip: {
      width: '100%',
      marginBottom: '12px',
      padding: '14px',
      backgroundColor: '#E4F4FB',
      borderRadius: '13px',
      [theme.breakpoints.down(480)]: {
        width: '170px',
        padding: '6px 14px',
        position: 'absolute',
        borderRadius: '50px',
        top: '-57px',
        right: '10px'
      },
    },
    text: {
      color: '#00A0DF',
      fontSize: '16px',
      [theme.breakpoints.down(480)]: {
        fontSize: '12px',
      },
    },
    textActive: {
      color: '#0047BA',
      fontWeight: 'bold',
      fontSize: '16px',
      [theme.breakpoints.down(480)]: {
        fontSize: '12px',
      },
    },
  })
);

export default useStyles;
